/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import './index.scss';

import { createRoot } from 'react-dom/client';
import invariant from 'tiny-invariant';

import App from '../src/App';

const rootElement = document.getElementById('recApp');
invariant(rootElement, 'Failed to find the root element');

const root = createRoot(rootElement);

root.render(<App />);
